/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";

import REJSTW from "./REJSTW";
import AcceptedRejectionsW1 from "./REJSTW1/rejection-2";
import AcceptedRejectionsW2 from "./REJSTW2/rejection-2";
import AcceptedRejectionsW3 from "./REJSTW3/rejection-2";

const cookies = new Cookies();

const RejectionsParent = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let REJSTWAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "13c26613-8372-4cb1-9dcf-da1388c0a4b5",
  );

  let REJSTW1Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "d1457511-7ff6-4d54-89a8-502d8d4e8dfb",
  );

  let REJSTW2Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "106b434d-02af-4c33-a016-ba1097296cc8",
  );

  let REJSTW3Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "08e7a781-bdd4-4b98-a8f7-4e6cdc822586",
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {REJSTWAccess ? (
              <REJSTW />
            ) : REJSTW1Access ? (
              <TabView>
                <TabPanel header="Accepted List ">
                  <AcceptedRejectionsW1 />
                </TabPanel>
              </TabView>
            ) : REJSTW2Access ? (
              <TabView>
                <TabPanel header="Accepted List ">
                  <AcceptedRejectionsW2 />
                </TabPanel>
              </TabView>
            ) : REJSTW3Access ? (
              <TabView>
                <TabPanel header="Accepted List ">
                  <AcceptedRejectionsW3 />
                </TabPanel>
              </TabView>
            ) : (
              <>
                <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                  No Rejection Access
                </h4>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(RejectionsParent);
